export default __webpack_public_path__ + "static/media/elvis.248e813d.png";